// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1rjZZ","alertIcon":"ConfirmModal_alertIcon__zOjkc"};